var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-calendar-item" }, [
    _c("div", [_vm._v(_vm._s(_vm.formatDate(_vm.calendarItem.date)))]),
    _vm._v(" "),
    _c("div", [_vm._v(_vm._s(_vm.calendarItem.heading))]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }